<template>
  <el-select
    ref="select"
    v-model="id"
    class="full-width"
    :placeholder="placeholder"
    :multiple="multiple"
    :collapse-tags="collapseTags"
    :disabled="disabled"
    filterable
    :clearable="clearable"
    :size="size"
    :loading="loading"
    @blur="onBlur"
    @change="onChange"
  >
    <el-option
      v-for="(item, index) in options"
      :key="index"
      :label="item['name']"
      :value="String(item['id'])"
    />
  </el-select>
</template>
<script>
import { userApi } from '@/api';
export default {
  name: 'BjMyRoles',
  props: {
    value: {
      type: [String, Number, Array, Boolean],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    collapseTags: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'mini',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    clearable: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'MENU',
    },
  },
  data() {
    return {
      api: userApi.getSelfRoles,
      id: this.$store.getters.roleId,
      options: [],
    };
  },
  watch: {
    value: {
      handler(v, o) {
        if (!this.$isSameArrayStringify(v, o)) {
          this.id = v;
        }
      },
      immediate: true,
    },
    id(v) {
      this.$emit('input', v);
    },
  },
  mounted() {
    this.api().then(res => {
      this.options = res;
    });
  },
  methods: {
    onBlur() {},
    getItem(v) {
      v = v || this.id;
      return this.options.find(e => e.id == v);
    },
    onChange(v) {
      const item = this.options.find(e => e.id == v);
      this.$emit('change', v, item);
    },
  },
};
</script>
